import { contexts } from 'constants/contexts';

const contextsThatHideHeader = [contexts.login];
const contextsThatHideSidebar = [contexts.login];

const hideElements = {
  contextsThatHideHeader,
  contextsThatHideSidebar,
};

export default hideElements;
